import produce from "immer";
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { POSTRequest } from "../../../../components/apiHandler";
import { logger } from "../../../../components/js";
import { GeneratePSVFormV4ReturnObject } from "../../../../forms/psv/generate_new_psv/v4";
import PDFGenerator from "../../../../forms/psv/generate_new_psv/v4/components/ReportPDF/generator";

// const data:GeneratePSVFormV4ReturnObject = {
//   "control_valve_data": [
//       {
//           "param": "Tag Name",
//           "value": "CV-1223"
//       },
//       {
//           "param": "Service",
//           "value": "Service #42"
//       },
//       {
//           "param": "Reference",
//           "value": "T-42"
//       },
//       {
//           "param": "HP",
//           "unit": "N",
//           "value": "500"
//       }
//   ],
//   "equipment_data": [
//       {
//           "param": "Tag Name",
//           "value": "PSV-2442"
//       },
//       {
//           "param": "Service",
//           "value": "S -24"
//       },
//       {
//           "param": "Reference",
//           "value": "155"
//       }
//   ],
//   "op": [
//       {
//           "scenario": {
//               "label": "Power Failure",
//               "value": "power_failure"
//           },
//           "identified": true,
//           "governing": true,
//           "stream": "2104",
//           "remarks": "<p>Power Failure Remark</p>"
//       },
//       {
//           "scenario": {
//               "label": "Steam Failure",
//               "value": "steam_failure"
//           },
//           "identified": true,
//           "governing": false,
//           "stream": "2104",
//           "remarks": "<p>Steam Failure Remark 2</p>"
//       },
//       {
//           "scenario": {
//               "label": "General Instrument Air Failure",
//               "value": "general_instrument_air_failure"
//           },
//           "identified": true,
//           "remarks": "<p>-&nbsp;</p>"
//       }
//   ],
//   "hysys": {
//       "pre": {
//           "text": "Material Stream: 2135-cv fail,Fluid Package: Basis-2\r\n,\r\n,Property Package: CPA\r\nCONDITIONS \r\n,Overall,Vapour Phase,Liquid Phase,,\r\nVapour / Phase Fraction ,0.9530,0.9530,0.0470,,\r\nTemperature: (C),68.70,68.70,68.70,,\r\nPressure: (kg/cm2_g),30.59,30.59,30.59,,\r\nMolar Flow (MMSCFD),7.850,7.481,0.3688,,\r\nMass Flow (kg/h),1.631e+004,1.553e+004,779.2,,\r\nStd Ideal Liq Vol Flow (MMcum/d),7.616e-004,7.254e-004,3.619e-005,,\r\nMolar Enthalpy (kJ/kgmole),-8728,-8214,-1.915e+004,,\r\nMolar Entropy (kJ/kgmole-C),85.31,86.65,57.98,,\r\nHeat Flow (MW),-0.9479,-0.8502,-9.773e-002,,\r\nLiq Vol Flow @Std Cond (MMcum/d),7.670e-004,7.309e-004,3.611e-005,,\r\nPROPERTIES \r\n,Overall,Vapour Phase,Liquid Phase,,\r\nMolecular Weight ,41.71,41.68,42.41,,\r\nMolar Density (kgmole/m3),1.762,1.693,9.660,,\r\nMass Density (kg/m3),73.49,70.58,409.7,,\r\nAct. Volume Flow (m3/h),221.9,220.0,1.902,,\r\nMass Enthalpy (kJ/kg),-209.2,-197.1,-451.5,,\r\nMass Entropy (kJ/kg-C),2.045,2.079,1.367,,\r\nHeat Capacity (kJ/kgmole-C),117.0,114.0,177.5,,\r\nMass Heat Capacity (kJ/kg-C),2.805,2.736,4.185,,\r\nLHV Molar Basis (Std) (kJ/kgmole),1.918e+006,1.916e+006,1.949e+006,,\r\nLHV Mass Basis (Std) (kJ/kg),4.597e+004,4.597e+004,4.595e+004,,\r\nPhase Fraction [Vol. Basis] ,0.9525,0.9525,4.752e-002,,\r\nPhase Fraction [Mass Basis] ,0.9522,0.9522,4.778e-002,,\r\nPartial Pressure of CO2 (kg/cm2_g),-1.032,,,,\r\nCost Based on Flow (Cost/s),0.0000,0.0000,0.0000,,\r\nAct. Gas Flow (ACT_m3/h),220.0,220.0,,,\r\nAvg. Liq. Density (kgmole/m3),12.32,12.33,12.18,,\r\nSpecific Heat (kJ/kgmole-C),117.0,114.0,177.5,,\r\nStd. Gas Flow (MMSCFD),7.835,7.467,0.3681,,\r\nStd. Ideal Liq. Mass Density (kg/m3),513.9,513.8,516.7,,\r\nAct. Liq. Flow (m3/h),1.902,,1.902,,\r\nZ Factor ,,0.6443,0.1130,,\r\nWatson K ,14.33,14.33,14.32,,\r\nUser Property ,,,,,\r\nPartial Pressure of H2S (kg/cm2_g),-1.033,,,,\r\nCp/(Cp - R) ,1.076,1.079,1.049,,\r\nCp/Cv ,1.645,1.716,1.992,,\r\nHeat of Vap. (kJ/kgmole),,,,,\r\nKinematic Viscosity (cSt),,0.1740,0.1021,,\r\nLiq. Mass Density (Std. Cond) (kg/m3),510.3,509.9,517.9,,\r\nLiq. Vol. Flow (Std. Cond) (MMcum/d),7.670e-004,7.309e-004,3.611e-005,,\r\nLiquid Fraction ,4.699e-002,0.0000,1.000,,\r\nMolar Volume (m3/kgmole),0.5676,0.5905,0.1035,,\r\nMass Heat of Vap. (kcal/kg),,,,,\r\nPhase Fraction [Molar Basis] ,0.9530,0.9530,0.0470,,\r\nSurface Tension (dyne/cm),1.907,,1.907,,\r\nThermal Conductivity (W/m-K),,2.700e-002,7.897e-002,,\r\nViscosity (cP),,1.228e-002,4.185e-002,,\r\nCv (Semi-Ideal) (kJ/kgmole-C),108.7,105.7,169.2,,\r\nMass Cv (Semi-Ideal) (kJ/kg-C),2.606,2.536,3.989,,\r\nCv (kJ/kgmole-C),71.12,66.45,89.13,,\r\nMass Cv (kJ/kg-C),1.705,1.594,2.101,,\r\nCv (Ent. Method) (kJ/kgmole-C),,,,,\r\nMass Cv (Ent. Method) (kJ/kg-C),,,,,\r\nCp/Cv (Ent. Method) ,,,,,\r\nReid VP at 37.8 C (kg/cm2_g),,,,,\r\nTrue VP at 37.8 C (kg/cm2_g),,,,,\r\nLiq. Vol. Flow - Sum(Std. Cond) (m3/h),31.96,30.46,1.505,,\r\nViscosity Index ,,,,,\r\nHHV Molar Basis (Std) (kJ/kgmole),2.048e+006,2.046e+006,2.081e+006,,\r\nHHV Mass Basis (Std) (kJ/kg),4.909e+004,4.909e+004,4.907e+004,,\r\nCO2 Loading ,,,,,\r\nCO2 Apparent Mole Conc. (kgmole/m3),,,1.692e-004,,\r\nCO2 Apparent Wt. Conc. (kgmol/kg),,,4.130e-007,,\r\nPhase Fraction [Act. Vol. Basis] ,0.9914,0.9914,8.570e-003,,\r\nMass Exergy (kJ/kg),180.1,,,,\r\nIdeal Gas Cp/Cv ,1.129,1.129,1.127,,\r\nIdeal Gas Cp (kJ/kgmole-C),72.77,72.72,73.82,,\r\nMass Ideal Gas Cp (kJ/kg-C),1.745,1.745,1.740,,\r\nBubble Point Pressure (kg/cm2_g),38.42,,,,\r\nCOMPOSITION \r\nOverall Phase ,Vapour Fraction 0.9530\r\n,\r\nCOMPONENTS,MOLAR FLOW,MOLE FRACTION,MASS FLOW,MASS FRACTION,LIQUID VOLUME,LIQUID VOLUME\r\n, (kgmole/h), , (kg/h), ,FLOW   (m3/h),FRACTION \r\nPropane,83.6517,0.2140,3688.7900,0.2262,7.2803,0.2294\r\nPropene,297.0100,0.7597,12498.3600,0.7664,23.9912,0.7560\r\nH2O,0.0183,0.0000,0.3300,0.0000,0.0003,0.0000\r\nMethane,6.5562,0.0168,105.1800,0.0064,0.3513,0.0111\r\nCO2,0.0175,0.0000,0.7700,0.0000,0.0009,0.0000\r\nCO,0.2999,0.0008,8.4000,0.0005,0.0105,0.0003\r\nHydrogen,3.4127,0.0087,6.8800,0.0004,0.0985,0.0031\r\nTotal ,390.9663,1.0000 ,16308.7100,1.0000 ,31.7332,1.0000 \r\nVapour Phase,Phase Fraction 0.9530\r\n,\r\nCOMPONENTS,MOLAR FLOW,MOLE FRACTION,MASS FLOW,MASS FRACTION,LIQUID VOLUME,LIQUID VOLUME\r\n, (kgmole/h), , (kg/h), ,FLOW   (m3/h),FRACTION \r\nPropane,79.3276,0.2129,3498.1091,0.2253,6.9040,0.2284\r\nPropene,283.0570,0.7597,11911.2072,0.7670,22.8642,0.7565\r\nH2O,0.0181,0.0000,0.3252,0.0000,0.0003,0.0000\r\nMethane,6.4794,0.0174,103.9484,0.0067,0.3472,0.0115\r\nCO2,0.0172,0.0000,0.7558,0.0000,0.0009,0.0000\r\nCO,0.2979,0.0008,8.3440,0.0005,0.0104,0.0003\r\nHydrogen,3.3984,0.0091,6.8511,0.0004,0.0981,0.0032\r\nTotal ,372.5955,1.0000 ,15529.5409,1.0000 ,30.2251,1.0000 \r\nLiquid Phase,Phase Fraction 4.699e-002\r\n,\r\nCOMPONENTS,MOLAR FLOW,MOLE FRACTION,MASS FLOW,MASS FRACTION,LIQUID VOLUME,LIQUID VOLUME\r\n, (kgmole/h), , (kg/h), ,FLOW   (m3/h),FRACTION \r\nPropane,4.3241,0.2354,190.6809,0.2447,0.3763,0.2496\r\nPropene,13.9531,0.7595,587.1528,0.7536,1.1271,0.7474\r\nH2O,0.0003,0.0000,0.0048,0.0000,0.0000,0.0000\r\nMethane,0.0768,0.0042,1.2316,0.0016,0.0041,0.0027\r\nCO2,0.0003,0.0000,0.0142,0.0000,0.0000,0.0000\r\nCO,0.0020,0.0001,0.0560,0.0001,0.0001,0.0000\r\nHydrogen,0.0143,0.0008,0.0289,0.0000,0.0004,0.0003\r\nTotal ,18.3708,1.0000 ,779.1691,1.0000 ,1.5080,1.0000 \r\nK VALUE \r\nCOMPONENTS,MIXED,LIGHT,HEAVY\r\nPropane,0.9045,0.9045,\r\nPropene,1.000,1.000,\r\nH2O,3.336,3.336,\r\nMethane,4.161,4.161,\r\nCO2,2.631,2.631,\r\nCO,7.347,7.347,\r\nHydrogen,11.71,11.71,\r\nUNIT OPERATIONS \r\nFEED TO ,PRODUCT FROM ,LOGICAL CONNECTION \r\nValve: V-101,Balance: BAL-1,\r\nUTILITIES \r\n( No utilities reference this stream ) \r\nPROCESS UTILITY \r\nDYNAMICS \r\nPressure Specification (Active):,30.59 kg/cm2_g,\r\nFlow Specification (Inactive),Molar: 7.850 MMSCFD,Mass: 1.631e+004 kg/h,Std Ideal Liq Volume: 7.616e-004 MMcum/d\r\nUser Variables \r\nNOTES \r\nDescription \r\n\r\n\r\n",
//           "value": {
//               "CONDITIONS": {
//                   "vapour/phasefraction": {
//                       "overall": "0.9530",
//                       "vapourphase": "0.9530",
//                       "liquidphase": "0.0470"
//                   },
//                   "temperature": {
//                       "unit": "C",
//                       "overall": "68.70",
//                       "vapourphase": "68.70",
//                       "liquidphase": "68.70"
//                   },
//                   "pressure": {
//                       "unit": "kg/cm2_g",
//                       "overall": "30.59",
//                       "vapourphase": "30.59",
//                       "liquidphase": "30.59"
//                   },
//                   "molarflow": {
//                       "unit": "MMSCFD",
//                       "overall": "7.850",
//                       "vapourphase": "7.481",
//                       "liquidphase": "0.3688"
//                   },
//                   "massflow": {
//                       "unit": "kg/h",
//                       "overall": "1.631e+004",
//                       "vapourphase": "1.553e+004",
//                       "liquidphase": "779.2"
//                   },
//                   "stdidealliqvolflow": {
//                       "unit": "MMcum/d",
//                       "overall": "7.616e-004",
//                       "vapourphase": "7.254e-004",
//                       "liquidphase": "3.619e-005"
//                   },
//                   "molarenthalpy": {
//                       "unit": "kJ/kgmole",
//                       "overall": "-8728",
//                       "vapourphase": "-8214",
//                       "liquidphase": "-1.915e+004"
//                   },
//                   "molarentropy": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "85.31",
//                       "vapourphase": "86.65",
//                       "liquidphase": "57.98"
//                   },
//                   "heatflow(mw)": {
//                       "overall": "-0.9479",
//                       "vapourphase": "-0.8502",
//                       "liquidphase": "-9.773e-002"
//                   },
//                   "liqvolflow@stdcond": {
//                       "unit": "MMcum/d",
//                       "overall": "7.670e-004",
//                       "vapourphase": "7.309e-004",
//                       "liquidphase": "3.611e-005"
//                   }
//               },
//               "PROPERTIES": {
//                   "molecularweight": {
//                       "overall": "41.71",
//                       "vapourphase": "41.68",
//                       "liquidphase": "42.41"
//                   },
//                   "molardensity": {
//                       "unit": "kgmole/m3",
//                       "overall": "1.762",
//                       "vapourphase": "1.693",
//                       "liquidphase": "9.660"
//                   },
//                   "massdensity": {
//                       "unit": "kg/m3",
//                       "overall": "73.49",
//                       "vapourphase": "70.58",
//                       "liquidphase": "409.7"
//                   },
//                   "act.volumeflow": {
//                       "unit": "m3/h",
//                       "overall": "221.9",
//                       "vapourphase": "220.0",
//                       "liquidphase": "1.902"
//                   },
//                   "massenthalpy": {
//                       "unit": "kJ/kg",
//                       "overall": "-209.2",
//                       "vapourphase": "-197.1",
//                       "liquidphase": "-451.5"
//                   },
//                   "massentropy": {
//                       "unit": "kJ/kg-C",
//                       "overall": "2.045",
//                       "vapourphase": "2.079",
//                       "liquidphase": "1.367"
//                   },
//                   "heatcapacity": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "117.0",
//                       "vapourphase": "114.0",
//                       "liquidphase": "177.5"
//                   },
//                   "massheatcapacity": {
//                       "unit": "kJ/kg-C",
//                       "overall": "2.805",
//                       "vapourphase": "2.736",
//                       "liquidphase": "4.185"
//                   },
//                   "lhvmolarbasis(std)": {
//                       "unit": "kJ/kgmole",
//                       "overall": "1.918e+006",
//                       "vapourphase": "1.916e+006",
//                       "liquidphase": "1.949e+006"
//                   },
//                   "lhvmassbasis(std)": {
//                       "unit": "kJ/kg",
//                       "overall": "4.597e+004",
//                       "vapourphase": "4.597e+004",
//                       "liquidphase": "4.595e+004"
//                   },
//                   "phasefraction[vol.basis]": {
//                       "overall": "0.9525",
//                       "vapourphase": "0.9525",
//                       "liquidphase": "4.752e-002"
//                   },
//                   "phasefraction[massbasis]": {
//                       "overall": "0.9522",
//                       "vapourphase": "0.9522",
//                       "liquidphase": "4.778e-002"
//                   },
//                   "partialpressureofco2": {
//                       "unit": "kg/cm2_g",
//                       "overall": "-1.032"
//                   },
//                   "costbasedonflow": {
//                       "unit": "Cost/s",
//                       "overall": "0.0000",
//                       "vapourphase": "0.0000",
//                       "liquidphase": "0.0000"
//                   },
//                   "act.gasflow": {
//                       "unit": "ACT_m3/h",
//                       "overall": "220.0",
//                       "vapourphase": "220.0"
//                   },
//                   "avg.liq.density": {
//                       "unit": "kgmole/m3",
//                       "overall": "12.32",
//                       "vapourphase": "12.33",
//                       "liquidphase": "12.18"
//                   },
//                   "specificheat": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "117.0",
//                       "vapourphase": "114.0",
//                       "liquidphase": "177.5"
//                   },
//                   "std.gasflow": {
//                       "unit": "MMSCFD",
//                       "overall": "7.835",
//                       "vapourphase": "7.467",
//                       "liquidphase": "0.3681"
//                   },
//                   "std.idealliq.massdensity": {
//                       "unit": "kg/m3",
//                       "overall": "513.9",
//                       "vapourphase": "513.8",
//                       "liquidphase": "516.7"
//                   },
//                   "act.liq.flow": {
//                       "unit": "m3/h",
//                       "overall": "1.902",
//                       "liquidphase": "1.902"
//                   },
//                   "zfactor": {
//                       "vapourphase": "0.6443",
//                       "liquidphase": "0.1130"
//                   },
//                   "watsonk": {
//                       "overall": "14.33",
//                       "vapourphase": "14.33",
//                       "liquidphase": "14.32"
//                   },
//                   "userproperty": {},
//                   "partialpressureofh2s": {
//                       "unit": "kg/cm2_g",
//                       "overall": "-1.033"
//                   },
//                   "cp/(cp-r)": {
//                       "overall": "1.076",
//                       "vapourphase": "1.079",
//                       "liquidphase": "1.049"
//                   },
//                   "cp/cv": {
//                       "overall": "1.645",
//                       "vapourphase": "1.716",
//                       "liquidphase": "1.992"
//                   },
//                   "heatofvap.": {
//                       "unit": "kJ/kgmole"
//                   },
//                   "kinematicviscosity(cst)": {
//                       "vapourphase": "0.1740",
//                       "liquidphase": "0.1021"
//                   },
//                   "liq.massdensity(std.cond)": {
//                       "unit": "kg/m3",
//                       "overall": "510.3",
//                       "vapourphase": "509.9",
//                       "liquidphase": "517.9"
//                   },
//                   "liq.vol.flow(std.cond)": {
//                       "unit": "MMcum/d",
//                       "overall": "7.670e-004",
//                       "vapourphase": "7.309e-004",
//                       "liquidphase": "3.611e-005"
//                   },
//                   "liquidfraction": {
//                       "overall": "4.699e-002",
//                       "vapourphase": "0.0000",
//                       "liquidphase": "1.000"
//                   },
//                   "molarvolume": {
//                       "unit": "m3/kgmole",
//                       "overall": "0.5676",
//                       "vapourphase": "0.5905",
//                       "liquidphase": "0.1035"
//                   },
//                   "massheatofvap.": {
//                       "unit": "kcal/kg"
//                   },
//                   "phasefraction[molarbasis]": {
//                       "overall": "0.9530",
//                       "vapourphase": "0.9530",
//                       "liquidphase": "0.0470"
//                   },
//                   "surfacetension": {
//                       "unit": "dyne/cm",
//                       "overall": "1.907",
//                       "liquidphase": "1.907"
//                   },
//                   "thermalconductivity(w/m-k)": {
//                       "vapourphase": "2.700e-002",
//                       "liquidphase": "7.897e-002"
//                   },
//                   "viscosity(cp)": {
//                       "vapourphase": "1.228e-002",
//                       "liquidphase": "4.185e-002"
//                   },
//                   "cv(semi-ideal)": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "108.7",
//                       "vapourphase": "105.7",
//                       "liquidphase": "169.2"
//                   },
//                   "masscv(semi-ideal)": {
//                       "unit": "kJ/kg-C",
//                       "overall": "2.606",
//                       "vapourphase": "2.536",
//                       "liquidphase": "3.989"
//                   },
//                   "cv": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "71.12",
//                       "vapourphase": "66.45",
//                       "liquidphase": "89.13"
//                   },
//                   "masscv": {
//                       "unit": "kJ/kg-C",
//                       "overall": "1.705",
//                       "vapourphase": "1.594",
//                       "liquidphase": "2.101"
//                   },
//                   "cv(ent.method)": {
//                       "unit": "kJ/kgmole-C"
//                   },
//                   "masscv(ent.method)": {
//                       "unit": "kJ/kg-C"
//                   },
//                   "cp/cv(ent.method)": {},
//                   "reidvpat37.8c": {
//                       "unit": "kg/cm2_g"
//                   },
//                   "truevpat37.8c": {
//                       "unit": "kg/cm2_g"
//                   },
//                   "liq.vol.flow-sum(std.cond)": {
//                       "unit": "m3/h",
//                       "overall": "31.96",
//                       "vapourphase": "30.46",
//                       "liquidphase": "1.505"
//                   },
//                   "viscosityindex": {},
//                   "hhvmolarbasis(std)": {
//                       "unit": "kJ/kgmole",
//                       "overall": "2.048e+006",
//                       "vapourphase": "2.046e+006",
//                       "liquidphase": "2.081e+006"
//                   },
//                   "hhvmassbasis(std)": {
//                       "unit": "kJ/kg",
//                       "overall": "4.909e+004",
//                       "vapourphase": "4.909e+004",
//                       "liquidphase": "4.907e+004"
//                   },
//                   "co2loading": {},
//                   "co2apparentmoleconc.": {
//                       "unit": "kgmole/m3",
//                       "liquidphase": "1.692e-004"
//                   },
//                   "co2apparentwt.conc.": {
//                       "unit": "kgmol/kg",
//                       "liquidphase": "4.130e-007"
//                   },
//                   "phasefraction[act.vol.basis]": {
//                       "overall": "0.9914",
//                       "vapourphase": "0.9914",
//                       "liquidphase": "8.570e-003"
//                   },
//                   "massexergy": {
//                       "unit": "kJ/kg",
//                       "overall": "180.1"
//                   },
//                   "idealgascp/cv": {
//                       "overall": "1.129",
//                       "vapourphase": "1.129",
//                       "liquidphase": "1.127"
//                   },
//                   "idealgascp": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "72.77",
//                       "vapourphase": "72.72",
//                       "liquidphase": "73.82"
//                   },
//                   "massidealgascp": {
//                       "unit": "kJ/kg-C",
//                       "overall": "1.745",
//                       "vapourphase": "1.745",
//                       "liquidphase": "1.740"
//                   },
//                   "bubblepointpressure": {
//                       "unit": "kg/cm2_g",
//                       "overall": "38.42"
//                   }
//               },
//               "COMPOSITION": {
//                   "Overall Phase": {
//                       "fraction": "0.9530",
//                       "Propane": {
//                           "molarflow(kgmole/h)": "83.6517",
//                           "molefraction": "0.2140",
//                           "massflow(kg/h)": "3688.7900",
//                           "massfraction": "0.2262",
//                           "liquidvolumeflow(m3/h)": "7.2803",
//                           "liquidvolumefraction": "0.2294"
//                       },
//                       "Propene": {
//                           "molarflow(kgmole/h)": "297.0100",
//                           "molefraction": "0.7597",
//                           "massflow(kg/h)": "12498.3600",
//                           "massfraction": "0.7664",
//                           "liquidvolumeflow(m3/h)": "23.9912",
//                           "liquidvolumefraction": "0.7560"
//                       },
//                       "H2O": {
//                           "molarflow(kgmole/h)": "0.0183",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.3300",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0003",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "Methane": {
//                           "molarflow(kgmole/h)": "6.5562",
//                           "molefraction": "0.0168",
//                           "massflow(kg/h)": "105.1800",
//                           "massfraction": "0.0064",
//                           "liquidvolumeflow(m3/h)": "0.3513",
//                           "liquidvolumefraction": "0.0111"
//                       },
//                       "CO2": {
//                           "molarflow(kgmole/h)": "0.0175",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.7700",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0009",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "CO": {
//                           "molarflow(kgmole/h)": "0.2999",
//                           "molefraction": "0.0008",
//                           "massflow(kg/h)": "8.4000",
//                           "massfraction": "0.0005",
//                           "liquidvolumeflow(m3/h)": "0.0105",
//                           "liquidvolumefraction": "0.0003"
//                       },
//                       "Hydrogen": {
//                           "molarflow(kgmole/h)": "3.4127",
//                           "molefraction": "0.0087",
//                           "massflow(kg/h)": "6.8800",
//                           "massfraction": "0.0004",
//                           "liquidvolumeflow(m3/h)": "0.0985",
//                           "liquidvolumefraction": "0.0031"
//                       },
//                       "Total ": {
//                           "molarflow(kgmole/h)": "390.9663",
//                           "molefraction": "1.0000 ",
//                           "massflow(kg/h)": "16308.7100",
//                           "massfraction": "1.0000 ",
//                           "liquidvolumeflow(m3/h)": "31.7332",
//                           "liquidvolumefraction": "1.0000 "
//                       }
//                   },
//                   "Vapour Phase": {
//                       "fraction": "0.9530",
//                       "Propane": {
//                           "molarflow(kgmole/h)": "79.3276",
//                           "molefraction": "0.2129",
//                           "massflow(kg/h)": "3498.1091",
//                           "massfraction": "0.2253",
//                           "liquidvolumeflow(m3/h)": "6.9040",
//                           "liquidvolumefraction": "0.2284"
//                       },
//                       "Propene": {
//                           "molarflow(kgmole/h)": "283.0570",
//                           "molefraction": "0.7597",
//                           "massflow(kg/h)": "11911.2072",
//                           "massfraction": "0.7670",
//                           "liquidvolumeflow(m3/h)": "22.8642",
//                           "liquidvolumefraction": "0.7565"
//                       },
//                       "H2O": {
//                           "molarflow(kgmole/h)": "0.0181",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.3252",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0003",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "Methane": {
//                           "molarflow(kgmole/h)": "6.4794",
//                           "molefraction": "0.0174",
//                           "massflow(kg/h)": "103.9484",
//                           "massfraction": "0.0067",
//                           "liquidvolumeflow(m3/h)": "0.3472",
//                           "liquidvolumefraction": "0.0115"
//                       },
//                       "CO2": {
//                           "molarflow(kgmole/h)": "0.0172",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.7558",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0009",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "CO": {
//                           "molarflow(kgmole/h)": "0.2979",
//                           "molefraction": "0.0008",
//                           "massflow(kg/h)": "8.3440",
//                           "massfraction": "0.0005",
//                           "liquidvolumeflow(m3/h)": "0.0104",
//                           "liquidvolumefraction": "0.0003"
//                       },
//                       "Hydrogen": {
//                           "molarflow(kgmole/h)": "3.3984",
//                           "molefraction": "0.0091",
//                           "massflow(kg/h)": "6.8511",
//                           "massfraction": "0.0004",
//                           "liquidvolumeflow(m3/h)": "0.0981",
//                           "liquidvolumefraction": "0.0032"
//                       },
//                       "Total ": {
//                           "molarflow(kgmole/h)": "372.5955",
//                           "molefraction": "1.0000 ",
//                           "massflow(kg/h)": "15529.5409",
//                           "massfraction": "1.0000 ",
//                           "liquidvolumeflow(m3/h)": "30.2251",
//                           "liquidvolumefraction": "1.0000 "
//                       }
//                   },
//                   "Liquid Phase": {
//                       "fraction": "4.699e-002",
//                       "Propane": {
//                           "molarflow(kgmole/h)": "4.3241",
//                           "molefraction": "0.2354",
//                           "massflow(kg/h)": "190.6809",
//                           "massfraction": "0.2447",
//                           "liquidvolumeflow(m3/h)": "0.3763",
//                           "liquidvolumefraction": "0.2496"
//                       },
//                       "Propene": {
//                           "molarflow(kgmole/h)": "13.9531",
//                           "molefraction": "0.7595",
//                           "massflow(kg/h)": "587.1528",
//                           "massfraction": "0.7536",
//                           "liquidvolumeflow(m3/h)": "1.1271",
//                           "liquidvolumefraction": "0.7474"
//                       },
//                       "H2O": {
//                           "molarflow(kgmole/h)": "0.0003",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.0048",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0000",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "Methane": {
//                           "molarflow(kgmole/h)": "0.0768",
//                           "molefraction": "0.0042",
//                           "massflow(kg/h)": "1.2316",
//                           "massfraction": "0.0016",
//                           "liquidvolumeflow(m3/h)": "0.0041",
//                           "liquidvolumefraction": "0.0027"
//                       },
//                       "CO2": {
//                           "molarflow(kgmole/h)": "0.0003",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.0142",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0000",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "CO": {
//                           "molarflow(kgmole/h)": "0.0020",
//                           "molefraction": "0.0001",
//                           "massflow(kg/h)": "0.0560",
//                           "massfraction": "0.0001",
//                           "liquidvolumeflow(m3/h)": "0.0001",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "Hydrogen": {
//                           "molarflow(kgmole/h)": "0.0143",
//                           "molefraction": "0.0008",
//                           "massflow(kg/h)": "0.0289",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0004",
//                           "liquidvolumefraction": "0.0003"
//                       },
//                       "Total ": {
//                           "molarflow(kgmole/h)": "18.3708",
//                           "molefraction": "1.0000 ",
//                           "massflow(kg/h)": "779.1691",
//                           "massfraction": "1.0000 ",
//                           "liquidvolumeflow(m3/h)": "1.5080",
//                           "liquidvolumefraction": "1.0000 "
//                       }
//                   },
//                   "components": {
//                       "overall": "MIXED",
//                       "vapourphase": "LIGHT",
//                       "liquidphase": "HEAVY"
//                   },
//                   "propane": {
//                       "overall": "0.9045",
//                       "vapourphase": "0.9045"
//                   },
//                   "propene": {
//                       "overall": "1.000",
//                       "vapourphase": "1.000"
//                   },
//                   "h2o": {
//                       "overall": "3.336",
//                       "vapourphase": "3.336"
//                   },
//                   "methane": {
//                       "overall": "4.161",
//                       "vapourphase": "4.161"
//                   },
//                   "co2": {
//                       "overall": "2.631",
//                       "vapourphase": "2.631"
//                   },
//                   "co": {
//                       "overall": "7.347",
//                       "vapourphase": "7.347"
//                   },
//                   "hydrogen": {
//                       "overall": "11.71",
//                       "vapourphase": "11.71"
//                   }
//               },
//               "UNIT OPERATIONS": {
//                   "valve:v-101": {
//                       "productfrom": "Balance: BAL-1"
//                   }
//               },
//               "UTILITIES": {},
//               "PROCESS UTILITY": {
//                   "pressurespecification(active)": {},
//                   "flowspecification(inactive)": {}
//               },
//               "User Variables": {},
//               "Description": {}
//           }
//       },
//       "to": {
//           "text": "Material Stream: PSV outlet,Fluid Package: Basis-2\r\n,\r\n,Property Package: CPA\r\nCONDITIONS \r\n,Overall,Vapour Phase,,,\r\nVapour / Phase Fraction ,1.0000,1.0000,,,\r\nTemperature: (C),16.50,16.50,,,\r\nPressure: (kg/cm2_g),6.118e-002,6.118e-002,,,\r\nMolar Flow (MMSCFD),7.850,7.850,,,\r\nMass Flow (kg/h),1.631e+004,1.631e+004,,,\r\nStd Ideal Liq Vol Flow (MMcum/d),7.616e-004,7.616e-004,,,\r\nMolar Enthalpy (kJ/kgmole),-8729,-8729,,,\r\nMolar Entropy (kJ/kgmole-C),110.0,110.0,,,\r\nHeat Flow (MW),-0.9479,-0.9479,,,\r\nLiq Vol Flow @Std Cond (MMcum/d),7.670e-004,7.670e-004,,,\r\nPROPERTIES \r\n,Overall,Vapour Phase,,,\r\nMolecular Weight ,41.71,41.71,,,\r\nMolar Density (kgmole/m3),4.523e-002,4.523e-002,,,\r\nMass Density (kg/m3),1.887,1.887,,,\r\nAct. Volume Flow (m3/h),8643,8643,,,\r\nMass Enthalpy (kJ/kg),-209.3,-209.3,,,\r\nMass Entropy (kJ/kg-C),2.637,2.637,,,\r\nHeat Capacity (kJ/kgmole-C),64.49,64.49,,,\r\nMass Heat Capacity (kJ/kg-C),1.546,1.546,,,\r\nLHV Molar Basis (Std) (kJ/kgmole),1.918e+006,1.918e+006,,,\r\nLHV Mass Basis (Std) (kJ/kg),4.597e+004,4.597e+004,,,\r\nPhase Fraction [Vol. Basis] ,1.000,1.000,,,\r\nPhase Fraction [Mass Basis] ,1.000,1.000,,,\r\nPartial Pressure of CO2 (kg/cm2_g),-1.033,,,,\r\nCost Based on Flow (Cost/s),0.0000,0.0000,,,\r\nAct. Gas Flow (ACT_m3/h),8643,8643,,,\r\nAvg. Liq. Density (kgmole/m3),12.32,12.32,,,\r\nSpecific Heat (kJ/kgmole-C),64.49,64.49,,,\r\nStd. Gas Flow (MMSCFD),7.835,7.835,,,\r\nStd. Ideal Liq. Mass Density (kg/m3),513.9,513.9,,,\r\nAct. Liq. Flow (m3/h),,,,,\r\nZ Factor ,0.9852,0.9852,,,\r\nWatson K ,14.33,14.33,,,\r\nUser Property ,,,,,\r\nPartial Pressure of H2S (kg/cm2_g),-1.033,,,,\r\nCp/(Cp - R) ,1.148,1.148,,,\r\nCp/Cv ,1.157,1.157,,,\r\nHeat of Vap. (kJ/kgmole),,,,,\r\nKinematic Viscosity (cSt),4.430,4.430,,,\r\nLiq. Mass Density (Std. Cond) (kg/m3),510.3,510.3,,,\r\nLiq. Vol. Flow (Std. Cond) (MMcum/d),7.670e-004,7.670e-004,,,\r\nLiquid Fraction ,0.0000,0.0000,,,\r\nMolar Volume (m3/kgmole),22.11,22.11,,,\r\nMass Heat of Vap. (kcal/kg),,,,,\r\nPhase Fraction [Molar Basis] ,1.0000,1.0000,,,\r\nSurface Tension (dyne/cm),,,,,\r\nThermal Conductivity (W/m-K),1.701e-002,1.701e-002,,,\r\nViscosity (cP),8.359e-003,8.359e-003,,,\r\nCv (Semi-Ideal) (kJ/kgmole-C),56.18,56.18,,,\r\nMass Cv (Semi-Ideal) (kJ/kg-C),1.347,1.347,,,\r\nCv (kJ/kgmole-C),55.72,55.72,,,\r\nMass Cv (kJ/kg-C),1.336,1.336,,,\r\nCv (Ent. Method) (kJ/kgmole-C),,,,,\r\nMass Cv (Ent. Method) (kJ/kg-C),,,,,\r\nCp/Cv (Ent. Method) ,,,,,\r\nReid VP at 37.8 C (kg/cm2_g),,,,,\r\nTrue VP at 37.8 C (kg/cm2_g),,,,,\r\nLiq. Vol. Flow - Sum(Std. Cond) (m3/h),31.96,31.96,,,\r\nViscosity Index ,,,,,\r\nHHV Molar Basis (Std) (kJ/kgmole),2.048e+006,2.048e+006,,,\r\nHHV Mass Basis (Std) (kJ/kg),4.909e+004,4.909e+004,,,\r\nCO2 Loading ,,,,,\r\nCO2 Apparent Mole Conc. (kgmole/m3),,,,,\r\nCO2 Apparent Wt. Conc. (kgmol/kg),,,,,\r\nPhase Fraction [Act. Vol. Basis] ,1.000,1.000,,,\r\nMass Exergy (kJ/kg),3.566,,,,\r\nIdeal Gas Cp/Cv ,1.149,1.149,,,\r\nIdeal Gas Cp (kJ/kgmole-C),63.97,63.97,,,\r\nMass Ideal Gas Cp (kJ/kg-C),1.534,1.534,,,\r\nBubble Point Pressure (kg/cm2_g),22.98,,,,\r\nCOMPOSITION \r\nOverall Phase ,Vapour Fraction 1.0000\r\n,\r\nCOMPONENTS,MOLAR FLOW,MOLE FRACTION,MASS FLOW,MASS FRACTION,LIQUID VOLUME,LIQUID VOLUME\r\n, (kgmole/h), , (kg/h), ,FLOW   (m3/h),FRACTION \r\nPropane,83.6517,0.2140,3688.7900,0.2262,7.2803,0.2294\r\nPropene,297.0100,0.7597,12498.3600,0.7664,23.9912,0.7560\r\nH2O,0.0183,0.0000,0.3300,0.0000,0.0003,0.0000\r\nMethane,6.5562,0.0168,105.1800,0.0064,0.3513,0.0111\r\nCO2,0.0175,0.0000,0.7700,0.0000,0.0009,0.0000\r\nCO,0.2999,0.0008,8.4000,0.0005,0.0105,0.0003\r\nHydrogen,3.4127,0.0087,6.8800,0.0004,0.0985,0.0031\r\nTotal ,390.9663,1.0000 ,16308.7100,1.0000 ,31.7332,1.0000 \r\nVapour Phase,Phase Fraction 1.000\r\n,\r\nCOMPONENTS,MOLAR FLOW,MOLE FRACTION,MASS FLOW,MASS FRACTION,LIQUID VOLUME,LIQUID VOLUME\r\n, (kgmole/h), , (kg/h), ,FLOW   (m3/h),FRACTION \r\nPropane,83.6517,0.2140,3688.7900,0.2262,7.2803,0.2294\r\nPropene,297.0100,0.7597,12498.3600,0.7664,23.9912,0.7560\r\nH2O,0.0183,0.0000,0.3300,0.0000,0.0003,0.0000\r\nMethane,6.5562,0.0168,105.1800,0.0064,0.3513,0.0111\r\nCO2,0.0175,0.0000,0.7700,0.0000,0.0009,0.0000\r\nCO,0.2999,0.0008,8.4000,0.0005,0.0105,0.0003\r\nHydrogen,3.4127,0.0087,6.8800,0.0004,0.0985,0.0031\r\nTotal ,390.9663,1.0000 ,16308.7100,1.0000 ,31.7332,1.0000 \r\nK VALUE \r\nCOMPONENTS,MIXED,LIGHT,HEAVY\r\nPropane,,,\r\nPropene,,,\r\nH2O,,,\r\nMethane,,,\r\nCO2,,,\r\nCO,,,\r\nHydrogen,,,\r\nUNIT OPERATIONS \r\nFEED TO ,PRODUCT FROM ,LOGICAL CONNECTION \r\n,Valve: PSV,\r\nUTILITIES \r\n( No utilities reference this stream ) \r\nPROCESS UTILITY \r\nDYNAMICS \r\nPressure Specification (Active):,6.118e-002 kg/cm2_g,\r\nFlow Specification (Inactive),Molar: 7.850 MMSCFD,Mass: 1.631e+004 kg/h,Std Ideal Liq Volume: 7.616e-004 MMcum/d\r\nUser Variables \r\nNOTES \r\nDescription \r\n\r\n\r\n",
//           "value": {
//               "CONDITIONS": {
//                   "vapour/phasefraction": {
//                       "overall": "1.0000",
//                       "vapourphase": "1.0000"
//                   },
//                   "temperature": {
//                       "unit": "C",
//                       "overall": "16.50",
//                       "vapourphase": "16.50"
//                   },
//                   "pressure": {
//                       "unit": "kg/cm2_g",
//                       "overall": "6.118e-002",
//                       "vapourphase": "6.118e-002"
//                   },
//                   "molarflow": {
//                       "unit": "MMSCFD",
//                       "overall": "7.850",
//                       "vapourphase": "7.850"
//                   },
//                   "massflow": {
//                       "unit": "kg/h",
//                       "overall": "1.631e+004",
//                       "vapourphase": "1.631e+004"
//                   },
//                   "stdidealliqvolflow": {
//                       "unit": "MMcum/d",
//                       "overall": "7.616e-004",
//                       "vapourphase": "7.616e-004"
//                   },
//                   "molarenthalpy": {
//                       "unit": "kJ/kgmole",
//                       "overall": "-8729",
//                       "vapourphase": "-8729"
//                   },
//                   "molarentropy": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "110.0",
//                       "vapourphase": "110.0"
//                   },
//                   "heatflow(mw)": {
//                       "overall": "-0.9479",
//                       "vapourphase": "-0.9479"
//                   },
//                   "liqvolflow@stdcond": {
//                       "unit": "MMcum/d",
//                       "overall": "7.670e-004",
//                       "vapourphase": "7.670e-004"
//                   }
//               },
//               "PROPERTIES": {
//                   "molecularweight": {
//                       "overall": "41.71",
//                       "vapourphase": "41.71"
//                   },
//                   "molardensity": {
//                       "unit": "kgmole/m3",
//                       "overall": "4.523e-002",
//                       "vapourphase": "4.523e-002"
//                   },
//                   "massdensity": {
//                       "unit": "kg/m3",
//                       "overall": "1.887",
//                       "vapourphase": "1.887"
//                   },
//                   "act.volumeflow": {
//                       "unit": "m3/h",
//                       "overall": "8643",
//                       "vapourphase": "8643"
//                   },
//                   "massenthalpy": {
//                       "unit": "kJ/kg",
//                       "overall": "-209.3",
//                       "vapourphase": "-209.3"
//                   },
//                   "massentropy": {
//                       "unit": "kJ/kg-C",
//                       "overall": "2.637",
//                       "vapourphase": "2.637"
//                   },
//                   "heatcapacity": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "64.49",
//                       "vapourphase": "64.49"
//                   },
//                   "massheatcapacity": {
//                       "unit": "kJ/kg-C",
//                       "overall": "1.546",
//                       "vapourphase": "1.546"
//                   },
//                   "lhvmolarbasis(std)": {
//                       "unit": "kJ/kgmole",
//                       "overall": "1.918e+006",
//                       "vapourphase": "1.918e+006"
//                   },
//                   "lhvmassbasis(std)": {
//                       "unit": "kJ/kg",
//                       "overall": "4.597e+004",
//                       "vapourphase": "4.597e+004"
//                   },
//                   "phasefraction[vol.basis]": {
//                       "overall": "1.000",
//                       "vapourphase": "1.000"
//                   },
//                   "phasefraction[massbasis]": {
//                       "overall": "1.000",
//                       "vapourphase": "1.000"
//                   },
//                   "partialpressureofco2": {
//                       "unit": "kg/cm2_g",
//                       "overall": "-1.033"
//                   },
//                   "costbasedonflow": {
//                       "unit": "Cost/s",
//                       "overall": "0.0000",
//                       "vapourphase": "0.0000"
//                   },
//                   "act.gasflow": {
//                       "unit": "ACT_m3/h",
//                       "overall": "8643",
//                       "vapourphase": "8643"
//                   },
//                   "avg.liq.density": {
//                       "unit": "kgmole/m3",
//                       "overall": "12.32",
//                       "vapourphase": "12.32"
//                   },
//                   "specificheat": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "64.49",
//                       "vapourphase": "64.49"
//                   },
//                   "std.gasflow": {
//                       "unit": "MMSCFD",
//                       "overall": "7.835",
//                       "vapourphase": "7.835"
//                   },
//                   "std.idealliq.massdensity": {
//                       "unit": "kg/m3",
//                       "overall": "513.9",
//                       "vapourphase": "513.9"
//                   },
//                   "act.liq.flow": {
//                       "unit": "m3/h"
//                   },
//                   "zfactor": {
//                       "overall": "0.9852",
//                       "vapourphase": "0.9852"
//                   },
//                   "watsonk": {
//                       "overall": "14.33",
//                       "vapourphase": "14.33"
//                   },
//                   "userproperty": {},
//                   "partialpressureofh2s": {
//                       "unit": "kg/cm2_g",
//                       "overall": "-1.033"
//                   },
//                   "cp/(cp-r)": {
//                       "overall": "1.148",
//                       "vapourphase": "1.148"
//                   },
//                   "cp/cv": {
//                       "overall": "1.157",
//                       "vapourphase": "1.157"
//                   },
//                   "heatofvap.": {
//                       "unit": "kJ/kgmole"
//                   },
//                   "kinematicviscosity(cst)": {
//                       "overall": "4.430",
//                       "vapourphase": "4.430"
//                   },
//                   "liq.massdensity(std.cond)": {
//                       "unit": "kg/m3",
//                       "overall": "510.3",
//                       "vapourphase": "510.3"
//                   },
//                   "liq.vol.flow(std.cond)": {
//                       "unit": "MMcum/d",
//                       "overall": "7.670e-004",
//                       "vapourphase": "7.670e-004"
//                   },
//                   "liquidfraction": {
//                       "overall": "0.0000",
//                       "vapourphase": "0.0000"
//                   },
//                   "molarvolume": {
//                       "unit": "m3/kgmole",
//                       "overall": "22.11",
//                       "vapourphase": "22.11"
//                   },
//                   "massheatofvap.": {
//                       "unit": "kcal/kg"
//                   },
//                   "phasefraction[molarbasis]": {
//                       "overall": "1.0000",
//                       "vapourphase": "1.0000"
//                   },
//                   "surfacetension": {
//                       "unit": "dyne/cm"
//                   },
//                   "thermalconductivity(w/m-k)": {
//                       "overall": "1.701e-002",
//                       "vapourphase": "1.701e-002"
//                   },
//                   "viscosity(cp)": {
//                       "overall": "8.359e-003",
//                       "vapourphase": "8.359e-003"
//                   },
//                   "cv(semi-ideal)": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "56.18",
//                       "vapourphase": "56.18"
//                   },
//                   "masscv(semi-ideal)": {
//                       "unit": "kJ/kg-C",
//                       "overall": "1.347",
//                       "vapourphase": "1.347"
//                   },
//                   "cv": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "55.72",
//                       "vapourphase": "55.72"
//                   },
//                   "masscv": {
//                       "unit": "kJ/kg-C",
//                       "overall": "1.336",
//                       "vapourphase": "1.336"
//                   },
//                   "cv(ent.method)": {
//                       "unit": "kJ/kgmole-C"
//                   },
//                   "masscv(ent.method)": {
//                       "unit": "kJ/kg-C"
//                   },
//                   "cp/cv(ent.method)": {},
//                   "reidvpat37.8c": {
//                       "unit": "kg/cm2_g"
//                   },
//                   "truevpat37.8c": {
//                       "unit": "kg/cm2_g"
//                   },
//                   "liq.vol.flow-sum(std.cond)": {
//                       "unit": "m3/h",
//                       "overall": "31.96",
//                       "vapourphase": "31.96"
//                   },
//                   "viscosityindex": {},
//                   "hhvmolarbasis(std)": {
//                       "unit": "kJ/kgmole",
//                       "overall": "2.048e+006",
//                       "vapourphase": "2.048e+006"
//                   },
//                   "hhvmassbasis(std)": {
//                       "unit": "kJ/kg",
//                       "overall": "4.909e+004",
//                       "vapourphase": "4.909e+004"
//                   },
//                   "co2loading": {},
//                   "co2apparentmoleconc.": {
//                       "unit": "kgmole/m3"
//                   },
//                   "co2apparentwt.conc.": {
//                       "unit": "kgmol/kg"
//                   },
//                   "phasefraction[act.vol.basis]": {
//                       "overall": "1.000",
//                       "vapourphase": "1.000"
//                   },
//                   "massexergy": {
//                       "unit": "kJ/kg",
//                       "overall": "3.566"
//                   },
//                   "idealgascp/cv": {
//                       "overall": "1.149",
//                       "vapourphase": "1.149"
//                   },
//                   "idealgascp": {
//                       "unit": "kJ/kgmole-C",
//                       "overall": "63.97",
//                       "vapourphase": "63.97"
//                   },
//                   "massidealgascp": {
//                       "unit": "kJ/kg-C",
//                       "overall": "1.534",
//                       "vapourphase": "1.534"
//                   },
//                   "bubblepointpressure": {
//                       "unit": "kg/cm2_g",
//                       "overall": "22.98"
//                   }
//               },
//               "COMPOSITION": {
//                   "Overall Phase": {
//                       "fraction": "1.0000",
//                       "Propane": {
//                           "molarflow(kgmole/h)": "83.6517",
//                           "molefraction": "0.2140",
//                           "massflow(kg/h)": "3688.7900",
//                           "massfraction": "0.2262",
//                           "liquidvolumeflow(m3/h)": "7.2803",
//                           "liquidvolumefraction": "0.2294"
//                       },
//                       "Propene": {
//                           "molarflow(kgmole/h)": "297.0100",
//                           "molefraction": "0.7597",
//                           "massflow(kg/h)": "12498.3600",
//                           "massfraction": "0.7664",
//                           "liquidvolumeflow(m3/h)": "23.9912",
//                           "liquidvolumefraction": "0.7560"
//                       },
//                       "H2O": {
//                           "molarflow(kgmole/h)": "0.0183",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.3300",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0003",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "Methane": {
//                           "molarflow(kgmole/h)": "6.5562",
//                           "molefraction": "0.0168",
//                           "massflow(kg/h)": "105.1800",
//                           "massfraction": "0.0064",
//                           "liquidvolumeflow(m3/h)": "0.3513",
//                           "liquidvolumefraction": "0.0111"
//                       },
//                       "CO2": {
//                           "molarflow(kgmole/h)": "0.0175",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.7700",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0009",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "CO": {
//                           "molarflow(kgmole/h)": "0.2999",
//                           "molefraction": "0.0008",
//                           "massflow(kg/h)": "8.4000",
//                           "massfraction": "0.0005",
//                           "liquidvolumeflow(m3/h)": "0.0105",
//                           "liquidvolumefraction": "0.0003"
//                       },
//                       "Hydrogen": {
//                           "molarflow(kgmole/h)": "3.4127",
//                           "molefraction": "0.0087",
//                           "massflow(kg/h)": "6.8800",
//                           "massfraction": "0.0004",
//                           "liquidvolumeflow(m3/h)": "0.0985",
//                           "liquidvolumefraction": "0.0031"
//                       },
//                       "Total ": {
//                           "molarflow(kgmole/h)": "390.9663",
//                           "molefraction": "1.0000 ",
//                           "massflow(kg/h)": "16308.7100",
//                           "massfraction": "1.0000 ",
//                           "liquidvolumeflow(m3/h)": "31.7332",
//                           "liquidvolumefraction": "1.0000 "
//                       }
//                   },
//                   "Vapour Phase": {
//                       "fraction": "1.000",
//                       "Propane": {
//                           "molarflow(kgmole/h)": "83.6517",
//                           "molefraction": "0.2140",
//                           "massflow(kg/h)": "3688.7900",
//                           "massfraction": "0.2262",
//                           "liquidvolumeflow(m3/h)": "7.2803",
//                           "liquidvolumefraction": "0.2294"
//                       },
//                       "Propene": {
//                           "molarflow(kgmole/h)": "297.0100",
//                           "molefraction": "0.7597",
//                           "massflow(kg/h)": "12498.3600",
//                           "massfraction": "0.7664",
//                           "liquidvolumeflow(m3/h)": "23.9912",
//                           "liquidvolumefraction": "0.7560"
//                       },
//                       "H2O": {
//                           "molarflow(kgmole/h)": "0.0183",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.3300",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0003",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "Methane": {
//                           "molarflow(kgmole/h)": "6.5562",
//                           "molefraction": "0.0168",
//                           "massflow(kg/h)": "105.1800",
//                           "massfraction": "0.0064",
//                           "liquidvolumeflow(m3/h)": "0.3513",
//                           "liquidvolumefraction": "0.0111"
//                       },
//                       "CO2": {
//                           "molarflow(kgmole/h)": "0.0175",
//                           "molefraction": "0.0000",
//                           "massflow(kg/h)": "0.7700",
//                           "massfraction": "0.0000",
//                           "liquidvolumeflow(m3/h)": "0.0009",
//                           "liquidvolumefraction": "0.0000"
//                       },
//                       "CO": {
//                           "molarflow(kgmole/h)": "0.2999",
//                           "molefraction": "0.0008",
//                           "massflow(kg/h)": "8.4000",
//                           "massfraction": "0.0005",
//                           "liquidvolumeflow(m3/h)": "0.0105",
//                           "liquidvolumefraction": "0.0003"
//                       },
//                       "Hydrogen": {
//                           "molarflow(kgmole/h)": "3.4127",
//                           "molefraction": "0.0087",
//                           "massflow(kg/h)": "6.8800",
//                           "massfraction": "0.0004",
//                           "liquidvolumeflow(m3/h)": "0.0985",
//                           "liquidvolumefraction": "0.0031"
//                       },
//                       "Total ": {
//                           "molarflow(kgmole/h)": "390.9663",
//                           "molefraction": "1.0000 ",
//                           "massflow(kg/h)": "16308.7100",
//                           "massfraction": "1.0000 ",
//                           "liquidvolumeflow(m3/h)": "31.7332",
//                           "liquidvolumefraction": "1.0000 "
//                       }
//                   }
//               },
//               "K VALUE": {
//                   "propane": {},
//                   "propene": {},
//                   "h2o": {},
//                   "methane": {},
//                   "co2": {},
//                   "co": {},
//                   "hydrogen": {}
//               },
//               "UNIT OPERATIONS": {
//                   "": {
//                       "productfrom": "Valve: PSV"
//                   }
//               },
//               "UTILITIES": {},
//               "PROCESS UTILITY": {
//                   "pressurespecification(active)": {},
//                   "flowspecification(inactive)": {}
//               },
//               "User Variables": {},
//               "Description": {}
//           }
//       },
//       "outlets": [
//           {
//               "out": {
//                   "text": "Material Stream: to PSV,Fluid Package: Basis-2\r\n,\r\n,Property Package: CPA\r\nCONDITIONS \r\n,Overall,Vapour Phase,,,\r\nVapour / Phase Fraction ,1.0000,1.0000,,,\r\nTemperature: (C),24.61,24.61,,,\r\nPressure: (kg/cm2_g),5.608,5.608,,,\r\nMolar Flow (MMSCFD),7.850,7.850,,,\r\nMass Flow (kg/h),1.631e+004,1.631e+004,,,\r\nStd Ideal Liq Vol Flow (MMcum/d),7.616e-004,7.616e-004,,,\r\nMolar Enthalpy (kJ/kgmole),-8729,-8729,,,\r\nMolar Entropy (kJ/kgmole-C),95.63,95.63,,,\r\nHeat Flow (MW),-0.9479,-0.9479,,,\r\nLiq Vol Flow @Std Cond (MMcum/d),7.670e-004,7.670e-004,,,\r\nPROPERTIES \r\n,Overall,Vapour Phase,,,\r\nMolecular Weight ,41.71,41.71,,,\r\nMolar Density (kgmole/m3),0.2886,0.2886,,,\r\nMass Density (kg/m3),12.04,12.04,,,\r\nAct. Volume Flow (m3/h),1355,1355,,,\r\nMass Enthalpy (kJ/kg),-209.3,-209.3,,,\r\nMass Entropy (kJ/kg-C),2.293,2.293,,,\r\nHeat Capacity (kJ/kgmole-C),69.07,69.07,,,\r\nMass Heat Capacity (kJ/kg-C),1.656,1.656,,,\r\nLHV Molar Basis (Std) (kJ/kgmole),1.918e+006,1.918e+006,,,\r\nLHV Mass Basis (Std) (kJ/kg),4.597e+004,4.597e+004,,,\r\nPhase Fraction [Vol. Basis] ,1.000,1.000,,,\r\nPhase Fraction [Mass Basis] ,1.000,1.000,,,\r\nPartial Pressure of CO2 (kg/cm2_g),-1.033,,,,\r\nCost Based on Flow (Cost/s),0.0000,0.0000,,,\r\nAct. Gas Flow (ACT_m3/h),1355,1355,,,\r\nAvg. Liq. Density (kgmole/m3),12.32,12.32,,,\r\nSpecific Heat (kJ/kgmole-C),69.07,69.07,,,\r\nStd. Gas Flow (MMSCFD),7.835,7.835,,,\r\nStd. Ideal Liq. Mass Density (kg/m3),513.9,513.9,,,\r\nAct. Liq. Flow (m3/h),,,,,\r\nZ Factor ,0.9117,0.9117,,,\r\nWatson K ,14.33,14.33,,,\r\nUser Property ,,,,,\r\nPartial Pressure of H2S (kg/cm2_g),-1.033,,,,\r\nCp/(Cp - R) ,1.137,1.137,,,\r\nCp/Cv ,1.203,1.203,,,\r\nHeat of Vap. (kJ/kgmole),,,,,\r\nKinematic Viscosity (cSt),0.7374,0.7374,,,\r\nLiq. Mass Density (Std. Cond) (kg/m3),510.3,510.3,,,\r\nLiq. Vol. Flow (Std. Cond) (MMcum/d),7.670e-004,7.670e-004,,,\r\nLiquid Fraction ,0.0000,0.0000,,,\r\nMolar Volume (m3/kgmole),3.465,3.465,,,\r\nMass Heat of Vap. (kcal/kg),,,,,\r\nPhase Fraction [Molar Basis] ,1.0000,1.0000,,,\r\nSurface Tension (dyne/cm),,,,,\r\nThermal Conductivity (W/m-K),1.844e-002,1.844e-002,,,\r\nViscosity (cP),8.876e-003,8.876e-003,,,\r\nCv (Semi-Ideal) (kJ/kgmole-C),60.76,60.76,,,\r\nMass Cv (Semi-Ideal) (kJ/kg-C),1.457,1.457,,,\r\nCv (kJ/kgmole-C),57.44,57.44,,,\r\nMass Cv (kJ/kg-C),1.377,1.377,,,\r\nCv (Ent. Method) (kJ/kgmole-C),,,,,\r\nMass Cv (Ent. Method) (kJ/kg-C),,,,,\r\nCp/Cv (Ent. Method) ,,,,,\r\nReid VP at 37.8 C (kg/cm2_g),,,,,\r\nTrue VP at 37.8 C (kg/cm2_g),,,,,\r\nLiq. Vol. Flow - Sum(Std. Cond) (m3/h),31.96,31.96,,,\r\nViscosity Index ,,,,,\r\nHHV Molar Basis (Std) (kJ/kgmole),2.048e+006,2.048e+006,,,\r\nHHV Mass Basis (Std) (kJ/kg),4.909e+004,4.909e+004,,,\r\nCO2 Loading ,,,,,\r\nCO2 Apparent Mole Conc. (kgmole/m3),,,,,\r\nCO2 Apparent Wt. Conc. (kgmol/kg),,,,,\r\nPhase Fraction [Act. Vol. Basis] ,1.000,1.000,,,\r\nMass Exergy (kJ/kg),106.3,,,,\r\nIdeal Gas Cp/Cv ,1.146,1.146,,,\r\nIdeal Gas Cp (kJ/kgmole-C),65.37,65.37,,,\r\nMass Ideal Gas Cp (kJ/kg-C),1.567,1.567,,,\r\nBubble Point Pressure (kg/cm2_g),24.26,,,,\r\nCOMPOSITION \r\nOverall Phase ,Vapour Fraction 1.0000\r\n,\r\nCOMPONENTS,MOLAR FLOW,MOLE FRACTION,MASS FLOW,MASS FRACTION,LIQUID VOLUME,LIQUID VOLUME\r\n, (kgmole/h), , (kg/h), ,FLOW   (m3/h),FRACTION \r\nPropane,83.6517,0.2140,3688.7900,0.2262,7.2803,0.2294\r\nPropene,297.0100,0.7597,12498.3600,0.7664,23.9912,0.7560\r\nH2O,0.0183,0.0000,0.3300,0.0000,0.0003,0.0000\r\nMethane,6.5562,0.0168,105.1800,0.0064,0.3513,0.0111\r\nCO2,0.0175,0.0000,0.7700,0.0000,0.0009,0.0000\r\nCO,0.2999,0.0008,8.4000,0.0005,0.0105,0.0003\r\nHydrogen,3.4127,0.0087,6.8800,0.0004,0.0985,0.0031\r\nTotal ,390.9663,1.0000 ,16308.7100,1.0000 ,31.7332,1.0000 \r\nVapour Phase,Phase Fraction 1.000\r\n,\r\nCOMPONENTS,MOLAR FLOW,MOLE FRACTION,MASS FLOW,MASS FRACTION,LIQUID VOLUME,LIQUID VOLUME\r\n, (kgmole/h), , (kg/h), ,FLOW   (m3/h),FRACTION \r\nPropane,83.6517,0.2140,3688.7900,0.2262,7.2803,0.2294\r\nPropene,297.0100,0.7597,12498.3600,0.7664,23.9912,0.7560\r\nH2O,0.0183,0.0000,0.3300,0.0000,0.0003,0.0000\r\nMethane,6.5562,0.0168,105.1800,0.0064,0.3513,0.0111\r\nCO2,0.0175,0.0000,0.7700,0.0000,0.0009,0.0000\r\nCO,0.2999,0.0008,8.4000,0.0005,0.0105,0.0003\r\nHydrogen,3.4127,0.0087,6.8800,0.0004,0.0985,0.0031\r\nTotal ,390.9663,1.0000 ,16308.7100,1.0000 ,31.7332,1.0000 \r\nK VALUE \r\nCOMPONENTS,MIXED,LIGHT,HEAVY\r\nPropane,,,\r\nPropene,,,\r\nH2O,,,\r\nMethane,,,\r\nCO2,,,\r\nCO,,,\r\nHydrogen,,,\r\nUNIT OPERATIONS \r\nFEED TO ,PRODUCT FROM ,LOGICAL CONNECTION \r\nValve: PSV,Valve: V-101,\r\nUTILITIES \r\n( No utilities reference this stream ) \r\nPROCESS UTILITY \r\nDYNAMICS \r\nPressure Specification (Active):,5.608 kg/cm2_g,\r\nFlow Specification (Inactive),Molar: 7.850 MMSCFD,Mass: 1.631e+004 kg/h,Std Ideal Liq Volume: 7.616e-004 MMcum/d\r\nUser Variables \r\nNOTES \r\nDescription \r\n\r\n\r\n",
//                   "value": {
//                       "CONDITIONS": {
//                           "vapour/phasefraction": {
//                               "overall": "1.0000",
//                               "vapourphase": "1.0000"
//                           },
//                           "temperature": {
//                               "unit": "C",
//                               "overall": "24.61",
//                               "vapourphase": "24.61"
//                           },
//                           "pressure": {
//                               "unit": "kg/cm2_g",
//                               "overall": "5.608",
//                               "vapourphase": "5.608"
//                           },
//                           "molarflow": {
//                               "unit": "MMSCFD",
//                               "overall": "7.850",
//                               "vapourphase": "7.850"
//                           },
//                           "massflow": {
//                               "unit": "kg/h",
//                               "overall": "1.631e+004",
//                               "vapourphase": "1.631e+004"
//                           },
//                           "stdidealliqvolflow": {
//                               "unit": "MMcum/d",
//                               "overall": "7.616e-004",
//                               "vapourphase": "7.616e-004"
//                           },
//                           "molarenthalpy": {
//                               "unit": "kJ/kgmole",
//                               "overall": "-8729",
//                               "vapourphase": "-8729"
//                           },
//                           "molarentropy": {
//                               "unit": "kJ/kgmole-C",
//                               "overall": "95.63",
//                               "vapourphase": "95.63"
//                           },
//                           "heatflow(mw)": {
//                               "overall": "-0.9479",
//                               "vapourphase": "-0.9479"
//                           },
//                           "liqvolflow@stdcond": {
//                               "unit": "MMcum/d",
//                               "overall": "7.670e-004",
//                               "vapourphase": "7.670e-004"
//                           }
//                       },
//                       "PROPERTIES": {
//                           "molecularweight": {
//                               "overall": "41.71",
//                               "vapourphase": "41.71"
//                           },
//                           "molardensity": {
//                               "unit": "kgmole/m3",
//                               "overall": "0.2886",
//                               "vapourphase": "0.2886"
//                           },
//                           "massdensity": {
//                               "unit": "kg/m3",
//                               "overall": "12.04",
//                               "vapourphase": "12.04"
//                           },
//                           "act.volumeflow": {
//                               "unit": "m3/h",
//                               "overall": "1355",
//                               "vapourphase": "1355"
//                           },
//                           "massenthalpy": {
//                               "unit": "kJ/kg",
//                               "overall": "-209.3",
//                               "vapourphase": "-209.3"
//                           },
//                           "massentropy": {
//                               "unit": "kJ/kg-C",
//                               "overall": "2.293",
//                               "vapourphase": "2.293"
//                           },
//                           "heatcapacity": {
//                               "unit": "kJ/kgmole-C",
//                               "overall": "69.07",
//                               "vapourphase": "69.07"
//                           },
//                           "massheatcapacity": {
//                               "unit": "kJ/kg-C",
//                               "overall": "1.656",
//                               "vapourphase": "1.656"
//                           },
//                           "lhvmolarbasis(std)": {
//                               "unit": "kJ/kgmole",
//                               "overall": "1.918e+006",
//                               "vapourphase": "1.918e+006"
//                           },
//                           "lhvmassbasis(std)": {
//                               "unit": "kJ/kg",
//                               "overall": "4.597e+004",
//                               "vapourphase": "4.597e+004"
//                           },
//                           "phasefraction[vol.basis]": {
//                               "overall": "1.000",
//                               "vapourphase": "1.000"
//                           },
//                           "phasefraction[massbasis]": {
//                               "overall": "1.000",
//                               "vapourphase": "1.000"
//                           },
//                           "partialpressureofco2": {
//                               "unit": "kg/cm2_g",
//                               "overall": "-1.033"
//                           },
//                           "costbasedonflow": {
//                               "unit": "Cost/s",
//                               "overall": "0.0000",
//                               "vapourphase": "0.0000"
//                           },
//                           "act.gasflow": {
//                               "unit": "ACT_m3/h",
//                               "overall": "1355",
//                               "vapourphase": "1355"
//                           },
//                           "avg.liq.density": {
//                               "unit": "kgmole/m3",
//                               "overall": "12.32",
//                               "vapourphase": "12.32"
//                           },
//                           "specificheat": {
//                               "unit": "kJ/kgmole-C",
//                               "overall": "69.07",
//                               "vapourphase": "69.07"
//                           },
//                           "std.gasflow": {
//                               "unit": "MMSCFD",
//                               "overall": "7.835",
//                               "vapourphase": "7.835"
//                           },
//                           "std.idealliq.massdensity": {
//                               "unit": "kg/m3",
//                               "overall": "513.9",
//                               "vapourphase": "513.9"
//                           },
//                           "act.liq.flow": {
//                               "unit": "m3/h"
//                           },
//                           "zfactor": {
//                               "overall": "0.9117",
//                               "vapourphase": "0.9117"
//                           },
//                           "watsonk": {
//                               "overall": "14.33",
//                               "vapourphase": "14.33"
//                           },
//                           "userproperty": {},
//                           "partialpressureofh2s": {
//                               "unit": "kg/cm2_g",
//                               "overall": "-1.033"
//                           },
//                           "cp/(cp-r)": {
//                               "overall": "1.137",
//                               "vapourphase": "1.137"
//                           },
//                           "cp/cv": {
//                               "overall": "1.203",
//                               "vapourphase": "1.203"
//                           },
//                           "heatofvap.": {
//                               "unit": "kJ/kgmole"
//                           },
//                           "kinematicviscosity(cst)": {
//                               "overall": "0.7374",
//                               "vapourphase": "0.7374"
//                           },
//                           "liq.massdensity(std.cond)": {
//                               "unit": "kg/m3",
//                               "overall": "510.3",
//                               "vapourphase": "510.3"
//                           },
//                           "liq.vol.flow(std.cond)": {
//                               "unit": "MMcum/d",
//                               "overall": "7.670e-004",
//                               "vapourphase": "7.670e-004"
//                           },
//                           "liquidfraction": {
//                               "overall": "0.0000",
//                               "vapourphase": "0.0000"
//                           },
//                           "molarvolume": {
//                               "unit": "m3/kgmole",
//                               "overall": "3.465",
//                               "vapourphase": "3.465"
//                           },
//                           "massheatofvap.": {
//                               "unit": "kcal/kg"
//                           },
//                           "phasefraction[molarbasis]": {
//                               "overall": "1.0000",
//                               "vapourphase": "1.0000"
//                           },
//                           "surfacetension": {
//                               "unit": "dyne/cm"
//                           },
//                           "thermalconductivity(w/m-k)": {
//                               "overall": "1.844e-002",
//                               "vapourphase": "1.844e-002"
//                           },
//                           "viscosity(cp)": {
//                               "overall": "8.876e-003",
//                               "vapourphase": "8.876e-003"
//                           },
//                           "cv(semi-ideal)": {
//                               "unit": "kJ/kgmole-C",
//                               "overall": "60.76",
//                               "vapourphase": "60.76"
//                           },
//                           "masscv(semi-ideal)": {
//                               "unit": "kJ/kg-C",
//                               "overall": "1.457",
//                               "vapourphase": "1.457"
//                           },
//                           "cv": {
//                               "unit": "kJ/kgmole-C",
//                               "overall": "57.44",
//                               "vapourphase": "57.44"
//                           },
//                           "masscv": {
//                               "unit": "kJ/kg-C",
//                               "overall": "1.377",
//                               "vapourphase": "1.377"
//                           },
//                           "cv(ent.method)": {
//                               "unit": "kJ/kgmole-C"
//                           },
//                           "masscv(ent.method)": {
//                               "unit": "kJ/kg-C"
//                           },
//                           "cp/cv(ent.method)": {},
//                           "reidvpat37.8c": {
//                               "unit": "kg/cm2_g"
//                           },
//                           "truevpat37.8c": {
//                               "unit": "kg/cm2_g"
//                           },
//                           "liq.vol.flow-sum(std.cond)": {
//                               "unit": "m3/h",
//                               "overall": "31.96",
//                               "vapourphase": "31.96"
//                           },
//                           "viscosityindex": {},
//                           "hhvmolarbasis(std)": {
//                               "unit": "kJ/kgmole",
//                               "overall": "2.048e+006",
//                               "vapourphase": "2.048e+006"
//                           },
//                           "hhvmassbasis(std)": {
//                               "unit": "kJ/kg",
//                               "overall": "4.909e+004",
//                               "vapourphase": "4.909e+004"
//                           },
//                           "co2loading": {},
//                           "co2apparentmoleconc.": {
//                               "unit": "kgmole/m3"
//                           },
//                           "co2apparentwt.conc.": {
//                               "unit": "kgmol/kg"
//                           },
//                           "phasefraction[act.vol.basis]": {
//                               "overall": "1.000",
//                               "vapourphase": "1.000"
//                           },
//                           "massexergy": {
//                               "unit": "kJ/kg",
//                               "overall": "106.3"
//                           },
//                           "idealgascp/cv": {
//                               "overall": "1.146",
//                               "vapourphase": "1.146"
//                           },
//                           "idealgascp": {
//                               "unit": "kJ/kgmole-C",
//                               "overall": "65.37",
//                               "vapourphase": "65.37"
//                           },
//                           "massidealgascp": {
//                               "unit": "kJ/kg-C",
//                               "overall": "1.567",
//                               "vapourphase": "1.567"
//                           },
//                           "bubblepointpressure": {
//                               "unit": "kg/cm2_g",
//                               "overall": "24.26"
//                           }
//                       },
//                       "COMPOSITION": {
//                           "Overall Phase": {
//                               "fraction": "1.0000",
//                               "Propane": {
//                                   "molarflow(kgmole/h)": "83.6517",
//                                   "molefraction": "0.2140",
//                                   "massflow(kg/h)": "3688.7900",
//                                   "massfraction": "0.2262",
//                                   "liquidvolumeflow(m3/h)": "7.2803",
//                                   "liquidvolumefraction": "0.2294"
//                               },
//                               "Propene": {
//                                   "molarflow(kgmole/h)": "297.0100",
//                                   "molefraction": "0.7597",
//                                   "massflow(kg/h)": "12498.3600",
//                                   "massfraction": "0.7664",
//                                   "liquidvolumeflow(m3/h)": "23.9912",
//                                   "liquidvolumefraction": "0.7560"
//                               },
//                               "H2O": {
//                                   "molarflow(kgmole/h)": "0.0183",
//                                   "molefraction": "0.0000",
//                                   "massflow(kg/h)": "0.3300",
//                                   "massfraction": "0.0000",
//                                   "liquidvolumeflow(m3/h)": "0.0003",
//                                   "liquidvolumefraction": "0.0000"
//                               },
//                               "Methane": {
//                                   "molarflow(kgmole/h)": "6.5562",
//                                   "molefraction": "0.0168",
//                                   "massflow(kg/h)": "105.1800",
//                                   "massfraction": "0.0064",
//                                   "liquidvolumeflow(m3/h)": "0.3513",
//                                   "liquidvolumefraction": "0.0111"
//                               },
//                               "CO2": {
//                                   "molarflow(kgmole/h)": "0.0175",
//                                   "molefraction": "0.0000",
//                                   "massflow(kg/h)": "0.7700",
//                                   "massfraction": "0.0000",
//                                   "liquidvolumeflow(m3/h)": "0.0009",
//                                   "liquidvolumefraction": "0.0000"
//                               },
//                               "CO": {
//                                   "molarflow(kgmole/h)": "0.2999",
//                                   "molefraction": "0.0008",
//                                   "massflow(kg/h)": "8.4000",
//                                   "massfraction": "0.0005",
//                                   "liquidvolumeflow(m3/h)": "0.0105",
//                                   "liquidvolumefraction": "0.0003"
//                               },
//                               "Hydrogen": {
//                                   "molarflow(kgmole/h)": "3.4127",
//                                   "molefraction": "0.0087",
//                                   "massflow(kg/h)": "6.8800",
//                                   "massfraction": "0.0004",
//                                   "liquidvolumeflow(m3/h)": "0.0985",
//                                   "liquidvolumefraction": "0.0031"
//                               },
//                               "Total ": {
//                                   "molarflow(kgmole/h)": "390.9663",
//                                   "molefraction": "1.0000 ",
//                                   "massflow(kg/h)": "16308.7100",
//                                   "massfraction": "1.0000 ",
//                                   "liquidvolumeflow(m3/h)": "31.7332",
//                                   "liquidvolumefraction": "1.0000 "
//                               }
//                           },
//                           "Vapour Phase": {
//                               "fraction": "1.000",
//                               "Propane": {
//                                   "molarflow(kgmole/h)": "83.6517",
//                                   "molefraction": "0.2140",
//                                   "massflow(kg/h)": "3688.7900",
//                                   "massfraction": "0.2262",
//                                   "liquidvolumeflow(m3/h)": "7.2803",
//                                   "liquidvolumefraction": "0.2294"
//                               },
//                               "Propene": {
//                                   "molarflow(kgmole/h)": "297.0100",
//                                   "molefraction": "0.7597",
//                                   "massflow(kg/h)": "12498.3600",
//                                   "massfraction": "0.7664",
//                                   "liquidvolumeflow(m3/h)": "23.9912",
//                                   "liquidvolumefraction": "0.7560"
//                               },
//                               "H2O": {
//                                   "molarflow(kgmole/h)": "0.0183",
//                                   "molefraction": "0.0000",
//                                   "massflow(kg/h)": "0.3300",
//                                   "massfraction": "0.0000",
//                                   "liquidvolumeflow(m3/h)": "0.0003",
//                                   "liquidvolumefraction": "0.0000"
//                               },
//                               "Methane": {
//                                   "molarflow(kgmole/h)": "6.5562",
//                                   "molefraction": "0.0168",
//                                   "massflow(kg/h)": "105.1800",
//                                   "massfraction": "0.0064",
//                                   "liquidvolumeflow(m3/h)": "0.3513",
//                                   "liquidvolumefraction": "0.0111"
//                               },
//                               "CO2": {
//                                   "molarflow(kgmole/h)": "0.0175",
//                                   "molefraction": "0.0000",
//                                   "massflow(kg/h)": "0.7700",
//                                   "massfraction": "0.0000",
//                                   "liquidvolumeflow(m3/h)": "0.0009",
//                                   "liquidvolumefraction": "0.0000"
//                               },
//                               "CO": {
//                                   "molarflow(kgmole/h)": "0.2999",
//                                   "molefraction": "0.0008",
//                                   "massflow(kg/h)": "8.4000",
//                                   "massfraction": "0.0005",
//                                   "liquidvolumeflow(m3/h)": "0.0105",
//                                   "liquidvolumefraction": "0.0003"
//                               },
//                               "Hydrogen": {
//                                   "molarflow(kgmole/h)": "3.4127",
//                                   "molefraction": "0.0087",
//                                   "massflow(kg/h)": "6.8800",
//                                   "massfraction": "0.0004",
//                                   "liquidvolumeflow(m3/h)": "0.0985",
//                                   "liquidvolumefraction": "0.0031"
//                               },
//                               "Total ": {
//                                   "molarflow(kgmole/h)": "390.9663",
//                                   "molefraction": "1.0000 ",
//                                   "massflow(kg/h)": "16308.7100",
//                                   "massfraction": "1.0000 ",
//                                   "liquidvolumeflow(m3/h)": "31.7332",
//                                   "liquidvolumefraction": "1.0000 "
//                               }
//                           }
//                       },
//                       "K VALUE": {
//                           "propane": {},
//                           "propene": {},
//                           "h2o": {},
//                           "methane": {},
//                           "co2": {},
//                           "co": {},
//                           "hydrogen": {}
//                       },
//                       "UNIT OPERATIONS": {
//                           "valve:psv": {
//                               "productfrom": "Valve: V-101"
//                           }
//                       },
//                       "UTILITIES": {},
//                       "PROCESS UTILITY": {
//                           "pressurespecification(active)": {},
//                           "flowspecification(inactive)": {}
//                       },
//                       "User Variables": {},
//                       "Description": {}
//                   }
//               }
//           }
//       ]
//   },
//   "additionalNotes": "<p>Notes <strong>EXTRA</strong></p>",
//   "assumptions": "<p>Test Basis</p><ol><li>Basis 1</li><li>Basis 2</li><li>Basis 3</li></ol>",
//   "recommendations": "<ol><li>First Recommendation</li><ol><li>Option One</li><li>Two</li></ol><li>Second Recommendation</li><ol><li>Option One</li><li>Two</li></ol></ol>",
//   "basic": {
//       "company": {
//           "value": 2,
//           "label": "Crooks PLC"
//       },
//       "project": {
//           "value": 1,
//           "label": "Test PRoject"
//       },
//       "cal_no": "CAL-24435",
//       "psv_tag": "PSV-2441552",
//       "location": "Top of D-1244",
//       "objective": "To observe P-24425"
//   },
//   "valve": {
//       "pressure": {
//           "set": {
//               "real": 0,
//               "value": 3575.988789835624,
//               "unit": {
//                 convert:'',
//                   "value": 4,
//                   "label": "barg"
//               }
//           },
//           "backpressure": {
//               "real": 0,
//               "value": -16.811017978756407,
//               "unit": {
//                 convert:'',
//                   "value": 0,
//                   "label": "kpa"
//               }
//           }
//       },
//       "type": {
//           "value": 1,
//           "label": "Conventional"
//       },
//       "rupture": true,
//       "cap_cert": true,
//       "orifice": {
//           "real": 0,
//           "value": 500,
//           "unit": {
//             convert:'',
//               "value": 0,
//               "label": "mm2"
//           }
//       },
//   },
//   "conclusions": "<p>Conclusion</p><ol><li>One</li><li>Two</li><li>Three</li></ol>",
//   "references": [
//       {
//           "ref": {
//               "value": 1,
//               "label": "API 520 (TEST)",
//               "author": "IEEE",
//               "year": 1980
//           },
//           "year": "1980-12-30T16:30:00.000Z",
//           "author": "IEEE"
//       },
//       {
//           "ref": {
//               "value": "Not a Test",
//               "label": "Not a Test",
//               "year": "",
//               "author": ""
//           },
//           "year": "2021-12-31T23:30:02.000Z",
//           "author": "Percy Wilburns"
//       },
//       {
//           "ref": {
//               "value": 1,
//               "label": "API 520 (TEST)",
//               "author": "IEEE",
//               "year": 1980
//           },
//           "year": "1980-12-30T16:30:00.000Z",
//           "author": "IEEE"
//       }
//   ],
//   "appendix": [
//       {
//           "name": "PSV DB",
//           "file": {
//               "name": "PSV outlet - pdf.pdf",
//               "rawFile": new File([],"test"),
//               "size": 37031,
//               "status": "File uploaded successfully",
//               "type": "pdf",
//               "validationMessages": '',
//               "statusCode": "2",
//               "id": "PSV outlet - pdf_9.pdf"
//           }
//       }
//   ]
// }

const Test = () => {
  const [reportValues, setReportValues] = useState({
    scenarios: [],
    orifices: [],
  });
  const [data, setData] = useState<GeneratePSVFormV4ReturnObject | null>(null);
  useEffect(() => {
    POSTRequest("report/generator.php", "INIT").then((response) => {
      logger.log("[Response] - ", response);
      setReportValues(response);
    });
  }, []);

  useEffect(() => {
    POSTRequest<GeneratePSVFormV4ReturnObject>(
      "report/psv.php",
      "GET_DATA_FOR_REPORT",
      { psv_id: 14 }
    ).then((response) => {
      const _response = produce(response, (draft) => {
        draft.hysys.pre.value = JSON.parse(draft.hysys.pre.value);
        draft.hysys.to.value = JSON.parse(draft.hysys.to.value);
        for (let i = 0; i < draft.hysys.outlets.length; i++) {
          draft.hysys.outlets[i].out.value = JSON.parse(
            draft.hysys.outlets[i].out.value
          );
        }
      });
      logger.log("[Response Report Data] - ", _response);
      setData(_response);
    });
  }, []);

  return (
    <Row className="w-100 " style={{ height: "100vh !important" }}>
      <Col xs={12} className="w-100 h-100"></Col>
      <Modal fullscreen show>
        <Modal.Body>
          {reportValues.orifices.length > 0 && data !== null && (
            <PDFGenerator data={data} reportValues={reportValues} />
          )}
        </Modal.Body>
      </Modal>
    </Row>
  );
};

export default Test;
